module.exports = __webpack_public_path__ + "static/media/pluricosmetica.7e19401d.webp";